export default __webpack_public_path__ + "static/media/spacefit3.726e3816.jpg";